import { useListCollectorUser } from "hooks";
import {
  useClearCollectorScheduleChanges,
  useListAllocateCollector,
} from "hooks/allocate-collector/useAllocateCollector";
import { useListRouteCollector } from "hooks/route-collector/useRouteCollector";
import { useTimeslotCollectorList } from "hooks/timeslot-collector/useTimeslotCollector";
import { useEffect, useMemo, useState } from "react";
import { cleanDays, groupRouteHaveSameInfomation } from "./utils";

const getInitAllocateCollectorParams = () => {
  return {
    sizePerPage: 10,
    page: -1,
    sort: "-checker_date",
    columnFilter: {
      "filter[is_odd_week]": 1,
    },
    columnFilterKeep: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "hub,route,timeSlot",
    run: false,
  };
};

const useCustomHook = () => {
  const [allocateCollectorParams, setAllocateCollectorParams] = useState(
    getInitAllocateCollectorParams
  );
  const [timeslotParams, setTimeslotParams] = useState({
    run: false,
    params: {
      page: -1,
    },
  });
  const [routeParams, setRouteParams] = useState({
    run: false,
    params: {
      page: -1,
    },
  });
  const [isSelectAllHub, setIsSelectAllHub] = useState(false);

  const { data: listAllocateCollector, refetch: fetchListAllocateCollector } =
    useListAllocateCollector({ params: allocateCollectorParams });

  const { data: listCollectorUser, refetch: fetchListCollectorUser } =
    useListCollectorUser();

  const { data: timeSlotCollector, refetch: fetchTimeSlotCollector } =
    useTimeslotCollectorList({
      params: timeslotParams.params,
    });
  const { data: routeCollector, refetch: fetchRouteCollector } =
    useListRouteCollector({
      params: routeParams.params,
    });

  const { isLoading: isLoadingClear, mutate: mutateClear } =
    useClearCollectorScheduleChanges(() => {
      fetchListAllocateCollector();
    });

  useEffect(() => {
    fetchListAllocateCollector();
  }, [allocateCollectorParams]);

  useEffect(() => {
    fetchListCollectorUser();
  }, []);

  useEffect(() => {
    if (timeslotParams.run) {
      fetchTimeSlotCollector();
    }
  }, [timeslotParams]);

  useEffect(() => {
    if (routeParams.run) {
      fetchRouteCollector();
    }
  }, [routeParams]);

  const listAllocateCollectorTableData = useMemo(() => {
    if (
      listAllocateCollector &&
      listAllocateCollector.items &&
      listAllocateCollector.items.length > 0
    ) {
      return groupRouteHaveSameInfomation(
        cleanDays(listAllocateCollector?.items)
      );
    }

    return [];
  }, [listAllocateCollector]);

  const hubSchedule = useMemo(() => {
    if (
      listAllocateCollectorTableData &&
      listAllocateCollectorTableData.length > 0
    ) {
      const firstRow = listAllocateCollectorTableData[0];
      return {
        id: firstRow?.hub?.id,
        is_center: firstRow?.hub?.is_center,
        name: firstRow?.hub?.name,
      };
    }

    return undefined;
  }, [listAllocateCollectorTableData]);

  const handleClearSchedule = async () => {
    if (hubSchedule) {
      mutateClear(hubSchedule.id);
    }
  };

  return {
    allocateCollectorParams,
    setAllocateCollectorParams,
    timeslotParams,
    setTimeslotParams,
    routeParams,
    setRouteParams,
    isSelectAllHub,
    setIsSelectAllHub,
    listAllocateCollector,
    listCollectorUser,
    timeSlotCollector,
    routeCollector,
    listAllocateCollectorTableData,
    hubSchedule,
    isLoadingClear,
    handleClearSchedule,
  };
};

export default useCustomHook;
